import { FC } from 'react';

import { STATUS_COLORS } from '../../../../constants';
import { IStatusLegendItem } from '../../../types';
import { StatusLegend } from '../StatusLegend';

export const ThresholdLegend: FC<{
  breakpoints: [number, number];
  higherIsBetter: boolean;
  labels?: { low: string; mid: string; high: string };
}> = ({
  breakpoints,
  higherIsBetter,
  labels = { low: 'Good', mid: 'OK', high: 'Poor' },
}) => {
  const [lo, hi] = breakpoints;
  const items: IStatusLegendItem[] = higherIsBetter
    ? [
        { color: STATUS_COLORS.poor.fill, label: `✗ ${labels.low}: <${lo}%` },
        {
          color: STATUS_COLORS.ok.fill,
          label: `~ ${labels.mid}: ${lo}–${hi}%`,
        },
        { color: STATUS_COLORS.good.fill, label: `✓ ${labels.high}: >${hi}%` },
      ]
    : [
        { color: STATUS_COLORS.good.fill, label: `✓ ${labels.low}: <${lo}%` },
        {
          color: STATUS_COLORS.ok.fill,
          label: `~ ${labels.mid}: ${lo}–${hi}%`,
        },
        { color: STATUS_COLORS.poor.fill, label: `✗ ${labels.high}: >${hi}%` },
      ];
  return <StatusLegend fontSize={11} marginTop={12} items={items} />;
};
